<form [formGroup]="areaRatioForm" *ngIf="areaRatioForm" (ngSubmit)="onSubmit()" class="myform">
    <div class="p-5">

        <div class="flex justify-center items-baseline flex-wrap">
            <div class="myradio">
              <mat-radio-group formControlName="options">
                <mat-radio-button value="1">Subsonic</mat-radio-button>
                <mat-radio-button value="2">Supersonic</mat-radio-button>
              </mat-radio-group>
           </div>

        </div>


        <div class="flex justify-center items-baseline flex-wrap">

        <div class="flex m-2">
          <mat-form-field>
            <input matInput placeholder="Gamma (ɣ) &nbsp; value" formControlName="gammaVal" autocomplete="off">
            <mat-error *ngIf="gamma?.invalid && gamma?.touched">
              <span class="myerror">1.0 &lt; ɣ &le; 1.67</span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="flex m-2">
  
          <mat-form-field>
            <input matInput placeholder="Area ratio" formControlName="areaRat" autocomplete="off">
            <mat-error *ngIf="areaRatio?.invalid && areaRatio?.touched">
              <span class="myerror">A/A* &gt; 1</span>
            </mat-error>
          </mat-form-field>
          </div>
        </div>
        </div>

        <div class="flex justify-center items-baseline flex-wrap sbmtArea">
    
      <!-- <div fxLayout="row" fxLayout.xs="column" fxLayoutWrap fxLayoutGap="5%" fxLayoutAlign="center" class=""> -->
        <button mat-raised-button type="submit" [disabled]="areaRatioForm.invalid">Calculate</button>
      </div>
      <br>

</form>
<div class="flex justify-center items-baseline flex-wrap" *ngIf="aBool">
    <br><br>
    <table>
      <tr>
        <td>
            <img src="assets/math/mach_b.svg" alt="">
        </td>
        <td> {{ isenMach()}} </td>
      </tr>
      <tr>
        <td>
            <img src="assets/math/ppt_b.svg" alt="">
        </td>
        <td>
          {{ isenp_pt() | number:'.1-5' }}
        </td>
      </tr>
      <tr>
        <td>
            <img src="assets/math/ttt_b2.svg" alt="">
        </td>
        <td>{{ isenT_Tt() | number:'.1-5'}}</td>
      </tr>
  
      <tr>
        <td>
            <img src="assets/math/paptas_b2.svg" alt="">
        </td>
        <td>
          {{ isenpA_ptAstar()  | number:'.1-5'  }}
        </td>
      </tr>
      <tr>
        <td>
            <img src="assets/math/pm_b2.svg" alt="">
        </td>
        <td>{{ isenpm() | number:'.1-5' }}</td>
      </tr>
      <tr>
        <td>
            <img src="assets/math/ma_b.svg" alt="">
        </td>
        <td>{{ isenmach_angle() | number:'.1-5' }}</td>
      </tr>
  
      <tr>
        <td>
            <img src="assets/math/cfopt_b3.svg" alt="">
        </td>
        <td>{{isen_cfopt() | number:'.1-5' }}</td>
      </tr>
  
      <tr>
  
        <td>
            <img src="assets/math/rhorhot_b.svg" alt="">
        </td>
        <td>{{ isen_rhot() | number:'.1-5' }}</td>
  
      </tr>
    </table>
  </div>